module.exports = __webpack_public_path__ + "static/media/lqgLf6I.246c1201.jpg";